<template>
  <div class="faqim-wrapper" @mouseenter="initSDK">
    <!-- parent guide -->
    <div class="icon guide-line" @click="handlerGoGuideLine">
      <div class="i"></div>
      <span>{{ res.guideline }}</span>
    </div>
    <!-- 新手须知 -->
    <div class="icon user-tutorial" @click="handlerUserTurorial">
      <div class="i"></div>
      <span>{{ res.user_tutorial }}</span>
    </div>

    <div class="icon im" @click="showIM(1)">
      <div class="i"></div>
      <span>{{ res.contract }}</span>
    </div>
  </div>
</template>

<script>
import { hobbitComponent } from 'hobbit-base';
import mediaView from 'hobbit-base/components/mediaview';
import IntlIMSDK from 'hobbit-base/components/bizs/im/client-im-sdk';
import {
  createLoaded,
  setSS,
  getSS,
  delSS,
} from 'hobbit-base/modules/utils';

const AUTO_SHOW_IM_FLAG = 'AUTO_SHOW_IM';

export default hobbitComponent({
  name: 'faqimbtn',
  data () {
    return {
      imSDK: null,
      getIMSDK: null,
      sdkStatus: 0, // 0：未初始化，1：初始化中，2：已初始化
      isMO: this.$ctx.vt === this.$ctx.VIEW_TYPE.M,
    };
  },
  created () {
    this.getIMSDK = createLoaded(async () => {
      this.imSDK = new IntlIMSDK();
      const isLogin = await this.$user.isLogin();
      // 初始化SDK
      return this.imSDK.lazyInit({
        imUrl: this.$config.custom.faqIMUrl.format({ lang: this.$ctx.lang }),
        biz: this.$ctx.biz,
        user: isLogin ? this.$user.vkUserId() : this.getGuestID(),
        onMessage: this.onIMMessage,
        onLoad: this.onIMLoad,
        onClose: this.onIMClose,
        onError: (errCode, errMsg) => {
          console.warn('IMError:', errCode, errMsg);
        },
        onNeedSignIn: (type) => {
          if (type === 'signup') {
            this.$app.pageTo('/signup/');
          } else {
            setSS(AUTO_SHOW_IM_FLAG, 1);
            this.$user.gotoLogin();
          }
          this.imSDK?.hideIM();
        },
        onMediaShow(type, url) {
          mediaView.show(type, url);
        },
      });
    });

    // 暴露全局API
    window.$FaqIMBtn = this;

    // 检查是否自动打开IM
    this.$user.isLogin().then(isLogin => {
      if (!isLogin) return;
      const autoShowIM = getSS(AUTO_SHOW_IM_FLAG);
      if (autoShowIM) {
        delSS(AUTO_SHOW_IM_FLAG);
        this.showIM(1);
      }
    });
  },
  destroyed() {
    this.imSDK?.destroyed();
  },
  methods: {
    initSDK() {
      this.getIMSDK();
    },
    showIM(tab) {
      this.getIMSDK().then(() => {
        this.imSDK.showIM(tab);
        this.$app.setPageScroll(false);
      });
      this.$log.tag('im_click', tab);
    },
    onIMLoad(type) {
      // 0未登录，1无消息，2有消息
    },
    onIMMessage() {

    },
    onIMClose() {
      // if (this.isMO) {
      this.$app.setPageScroll(true);
      // }
    },
    getGuestID() {
      return `GUEST-${this.$ctx.deviceID}`;
    },
    handlerGoGuideLine() {
      window.open(`/${this.$ctx.lang}/cms/html/?key=L06LKLQMGWYLA0TK&footer=true&width=1080px&faqim=`);
    },
    handlerUserTurorial() {
      window.open(`/${this.$ctx.lang}/cms/html/?key=L06LLJII2X6P6Y3G&footer=true&width=1080px&faqim=`);
    },
  },
});
</script>
<style lang="less">
@import '~@/styles/index.less';
.intl-im-frame {
  position: fixed;
  z-index: @ZINDEX_COVER + 99;
  // background-color: transparent;
  background-color: #fff;
  bottom: 0;
  top: 0;
  right: -510px;
  width: 500px;
  height: 100%;
  transition: all 0.5s cubic-bezier(0.3, 1, 0.3, 1);
  box-shadow: 0 6px 12px 0 rgba(0,0,0,0.2);
  border: none;
}
.intl-im-frame.show {
  right: 0;
}

.faqim-wrapper {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: @ZINDEX_COVER - 10;
  .icon {
    margin-bottom: 0.4rem;
    width: 0.72rem;
    height: 0.65rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: @THEME_COLOR;
    font-size: 0.12rem;
    line-height: 0.14rem;
    background: #ffffff;
    border-radius: 0.16rem 0 0 0.16rem;
    box-shadow: 0 0.04rem 0.1rem 0 rgba(0,0,0,0.04);
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    .i {
      margin-bottom: 0.04rem;
      width: 0.3rem;
      height: 0.3rem;
      background-size: 100% 100% !important;
      transition: all 0.3s;
    }
    &.im {
      color: #fff;
      background: @THEME_COLOR;
      .i {
        background: url('./images/icon-contract.png') no-repeat center;
      }
    }
    &.faq {
      .i {
        background: url('./images/icon-faq.png') no-repeat center;
      }
    }
    &.guide-line {
      display: none;
      margin-bottom: 0.1rem;
      .i {
        background: url('./images/icon-guide.png') no-repeat center;
      }
    }
    &.user-tutorial {
      display: none;
      margin-bottom: 0.6rem;
      .i {
        background: url('./images/icon-student.png') no-repeat center;
      }
    }
  }
}

@media screen and (max-device-width: 639px) {
  .intl-im-frame {
    width: 100%;
    height: 100%;
    bottom: -120%;
    top: auto;
    right: 0;
    box-shadow: none;
    border-radius: 0;
  }
  .intl-im-frame.show {
    bottom: 0;
    right: 0;
  }
  .faqim-wrapper {
    top: 70%;
    .icon {
      width: 0.68rem;
      height: 0.6rem;
    }
  }
}
</style>
